import type { ClientOptions } from 'openapi-fetch';
import { useMemo } from 'react';
import { useStore } from 'react-redux';

import { createClient } from '../api/createClient';

export const useClient = <TPaths extends object>(options?: ClientOptions) => {
  const store = useStore();
  return useMemo(() => createClient<TPaths>(store, options), [store, options]);
};
